exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dropped-element.selected{outline:3px solid cyan}.mdl-selectfield{margin-bottom:20px}.mdl-selectfield__select[disabled]{opacity:.3}.mdl-selectfield__placeholder{bottom:0;cursor:pointer;color:#999;left:0;padding:2px 0;position:absolute;text-align:right;top:10;width:100%;z-index:1}.mdl-selectfield__placeholder>i{outline:0}.mdl-selectfield select{z-index:2;position:absolute;cursor:pointer}#objectDetails{background-color:hsla(0,0%,62%,.15);margin-bottom:0;padding:10px;zoom:.8}#objectCollection{background-color:#ccc;margin:0;padding:0}.mdl-selectfield select.is-none{color:#aaa}.mdl-selectfield select.is-none option{color:#2c3e50}.mdl-selectfield option.is-none,.mdl-selectfield select.is-none option.is-none{color:#aaa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-0232f936!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionStageCompose.vue
// module id = 219
// module chunks = 0